"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinObjectList = void 0;
function joinObjectList(list, columnKey, divider) {
    let str = '';
    for (let i = 0; i < list.length; i++) {
        str += list[i][columnKey] + (i !== list.length - 1 ? divider : '');
    }
    str.trim();
    return str;
}
exports.joinObjectList = joinObjectList;
//# sourceMappingURL=joinObjectList.js.map